import React, {Component, useEffect} from 'react';
import { ProGallery } from 'pro-gallery';
import 'pro-gallery/dist/statics/main.css';
import { Fancybox } from "@fancyapps/ui";
export default function Gallery() {
    // Add your images here...
    const [dimensions, setDimensions] = React.useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const gallery = [];
    let items = window.salkovo_gal_items.map((item,index)=>{
        // console.log('item',item)

        gallery.push({
            src: item.metaData.link.url,
            thumb: item.metaData.link.url,
            caption: item.metaData.link.title
        });

        item.itemId = 'id'+index;
        return item;
    });
    // console.log('items',items)

    // The options of the gallery (from the playground current state)
    const options = {
        // galleryLayout: -1,
        galleryLayout: 0,
        showVideoPlayButton: true,
        hidePlay: false,
        isVertical: false,
        chooseBestGroup: true,
        fixedColumns: 0,
        placeGroupsLtr: false,
        thumbnailSpacings: 5,
        thumbnailSize: 120,
        minItemSize: 120,
        scatter: 0,
        groupsPerStrip: 0,
        cropOnlyFill: false,
        hasThumbnails: false,
        smartCrop: false,
        cubeImages: false,
        scrollDirection: 0,
        externalInfoWidth: 0,
        externalInfoHeight: 0,
        layoutParams_gallerySpacing: 0,
        slideshowInfoSize: 200,
        targetItemSize: 660,
        imageMargin: 10,
        collageDensity: 1,
        cubeRatio: 1,
        layoutParams_cropRatio: 1,
        groupSize: 3,
        collageAmount: 0.8,
        groupTypes: '1,2h,2v,3t,3b,3l,3r',
        galleryThumbnailsAlignment: 'bottom',
        cubeType: 'fit',
        layoutParams_repeatingGroupTypes: '',
        rotatingCropRatios: '',
    };

    // The size of the gallery container. The images will fit themselves in it
    const container = {
        width: window.innerWidth,
        height: window.innerHeight
    };

    // The eventsListener will notify you anytime something has happened in the gallery.
    const eventsListener = (eventName, eventData) => {
        // console.log({eventName, eventData})
        if (eventName === 'ITEM_CLICKED' && eventData.linkUrl) {

            // console.log('eventData',eventData)
            Fancybox.show(gallery, {
                // Your options go here
            }).jumpTo(eventData.idx);
        }
    };

    // The scrollingElement is usually the window, if you are scrolling inside another element, suplly it here
    const scrollingElement = window;

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    return (
        <ProGallery
            items={items}
            options={options}
            container={container}
            eventsListener={eventsListener}
            scrollingElement={scrollingElement}
        />
    );
}
